import { StrictNullable } from '@/shared/types/app.types'
import { InvoiceResponse } from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { InvoicePaymentResponse } from '@/api/services/billing/invoice-payment/billing-invoice-payment.dto'
import { AppliedBillableConceptResponse } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'

export interface BillingModalInvoicePaymentParams {
    invoice?: InvoiceResponse
    invoicePayment?: InvoicePaymentResponse
    selectionMode?: boolean
}

export interface BillingModalInvoicePaymentState {
    invoice: StrictNullable<InvoiceResponse>
    invoicePayment: StrictNullable<InvoicePaymentResponse>
    selectionMode: boolean
    addToMode: boolean
    conceptsTotalCount: number
    appliedBillableConcepts: AppliedBillableConceptResponse[]
}
export const initialBillingModalInvoicePaymentState =
    (): BillingModalInvoicePaymentState => ({
        invoice: null,
        invoicePayment: null,
        selectionMode: true,
        addToMode: false,
        conceptsTotalCount: 0,
        appliedBillableConcepts: []
    })
